<template>
  <sc-page-base :title="title" :loading="loading">
  <sc-form 
    :form="lpData"
    :rules="dynamicRules"
    @change="updateQuoteTable"
    @submit="createTickets">

    {{ this.shouldIntegrationLp }}

   <template
      slot="fields"
      slot-scope="{ fields }">
      <div> 
        <p class="title-company is-5">Dados da Empresa</p>
        <div class="columns">
          <div class="column is-4">
            <sc-field label="Nome do solicitante" prop="client_name" class="field-company">
              <sc-input 
                placeholder="Nome do solicitante"
                v-model="fields.client_name"
                type="text">
              </sc-input>
            </sc-field>
          </div>
          <div class="column is-4">
            <sc-field label="Telefone do solicitante" prop="client_phone_number" class="field-company">
              <sc-input 
                placeholder="(DDD + Telefone + Ramal)"
                v-model="fields.client_phone_number"
                type="text">
              </sc-input>
            </sc-field>
          </div>
          <div class="column is-4">
            <sc-field label="E-mail do solicitante" prop="client_email" class="field-company">
              <sc-input 
                placeholder="E-mail corporativo"
                v-model="fields.client_email"
                type="email"
                name="client_email">
              </sc-input>
            </sc-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <sc-field label="Nome do responsável na transportadora" prop="lp_contact_name" class="field-company">
              <sc-input 
                placeholder="Nome do responsável na transportadora"
                v-model="fields.lp_contact_name"
                type="text">
              </sc-input>
            </sc-field>
          </div>
          <div class="column is-4">
            <sc-field label="Telefone do responsável na transportadora" prop="lp_contact_phone_number" class="field-company">
              <sc-input 
                placeholder="Telefone do responsável na transportadora."
                v-model="fields.lp_contact_phone_number"
                type="text"></sc-input>
            </sc-field>
          </div>
          <div class="column is-4">
            <sc-field label="E-mail do responsável na transportadora" prop="lp_contact_email" class="field-company">
              <sc-input 
                placeholder="E-mail do responsável na transportadora"
                v-model="fields.lp_contact_email"
                type="email"
                name="lp_contact_email">
              </sc-input>
            </sc-field>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-6">
            <sc-field label="Nome da transportadora" prop="logistic_provider" class="field-company">
              <sc-select
                v-model="fields.logistic_provider"
                class="lp-select">
                <option  
                  v-for="lp in logisticProviderList"
                  :value="lp"
                  :key="lp">
                  {{ lp }}
                </option>
              </sc-select>
            </sc-field>
            <p class="detail-logistic-provider">Caso não localize a transportadora desejada, escolha a opção "Outra Transportadora" e informe mais detalhes no campo "Outros comentários relevantes".</p>
          </div>
          <div class="column is-6">
            <p class="field-company">Informe os CNPJs dos centros de distribuição de sua operação <b class="required">*</b></p>

            <sc-field prop="warehouses">
              <sc-multiple-warehouse-search
              v-model="fields.warehouses"
              :options="warehouses"
              :clearSelectedWarehouses="clearSelectedWarehouses"
              @selectAll="values => handleSelectAll(fields, values)"
              @clearFilterSelected="handleClearFilter(fields)"
              @input="handleWarehouseSelection(fields)"
              class="multiple-select"
            />
            </sc-field>
          </div>
        </div>
        <hr>
        <div class="columns">
          <div class="column is-6">
            <sc-field label="Tipo de integração" prop="client_modules" class="field-company">
              <sc-select
                v-model="fields.client_modules">
                <option  
                  v-for="clientModule in clientModulesList"
                  :value="clientModule.value"
                  :key="clientModule.key">
                  {{ clientModule.label }}
                </option>
              </sc-select>
            </sc-field>
          </div>
          <div class="column is-5">
            <sc-field label="Número de contrato ou OS transportador" prop="contract_number" class="field-company">
              <sc-input
                placeholder="Número de contrato ou OS transportador"
                v-model="fields.contract_number"
                type="text">
              </sc-input>
            </sc-field>
          </div>
        </div>

        <sc-field class="term" prop="has_contract">
          <sc-checkbox 
            v-model="fields.has_contract" 
            class="term-check">
            Confirmo que essa integração está acordada e com contrato finalizado com o transportador escolhido.
          </sc-checkbox>
        </sc-field>
        <p class="title-company is-5">Deseja incluir uma tabela de frete?</p>
        <div class="flat-switch">
          <sc-switch 
            class="switch-add"
            v-model="fields.include_quote_table"/>
            {{ fields.include_quote_table ? 'Sim' : 'Não' }}
        </div>
        <div>
          <new-quote-table-form 
            v-if="fields.include_quote_table"
            v-model="fields.quote_table">
          </new-quote-table-form>
        </div>
        <hr>
        <div>
          <sc-field label="Outros comentários relevantes" class="field-company">
              <sc-input
                type="textarea"
                v-model="fields.additional_information"
                placeholder="Adicione comentários relevantes ou informações específicas da integração.">
              </sc-input>
            </sc-field>
        </div>
        <div>
          <sc-field class="term term-align" prop="client_consent">
            <sc-checkbox 
              v-model="fields.client_consent"
              class="term-check">
              Li e concordo com os  <a class="term-text" @click="openModal">termos e condições</a>
            </sc-checkbox>
          </sc-field>
          <sc-term-modal :modal-active="modal" @close="closeModal"/>
        </div>
      </div>
    </template>

    <template slot="actions" slot-scope="{ isValid }">
      <sc-button
          type="submit"
          theme="primary"
          text="Enviar"
          :loading="loading"/>
    </template>
  </sc-form>
  </sc-page-base>
</template>
  
<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScPageBase,
    ScForm,
    ScInput,
    ScField,
    ScButton,
    ScSelect,
    ScRadio,
    ScCheckbox,
    ScSwitch,
    ScMultipleSelection,
    ScMultipleWarehouseSearch,
    ScToast,
    ScAutocomplete,
    ScTaginput,
  } from '@intelipost-js/secure-components';

  import NewQuoteTableForm from './NewQuoteTableForm.vue';
  import ScTermModal from './components/ScTermModal/ScTermModal.vue';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
    'integrations/integrationsAppSelfService',
  );

  export default {
    name: 'new-logistic-provider-form',
    props: ['shouldIntegrationLp'],
    data() {
      return {
        title: this.shouldIntegrationLp === false ? 'Adicionar método' : 'Solicitação de Nova Transportadora',
        filteredOptionsWarehouses: [],
        selectAll: false,
        selectedTags: [],
        searchText: '',
        clearSelectedWarehouses: false,
        selectedOptions: false,
        lpData: {
          logistic_provider: '',
          warehouses: [],
          include_quote_table: false,
          quote_table: {
            quote_table_type: 'Padrão Transportadora - Validação comercial + 8 dias úteis para implantação',
            additional_table_type: 'NONE',
            vtex_origin_zip_code: '',
            linx_type: '',
            origin_type: 'Centro de Distribuição Único',
            warehouse_initial_zip_code: '',
            warehouse_final_zip_code: '',
            client_ids_to_replicate: '',
            quote_table_files: [],
            inteli_envios_lp: [],
            inteli_envios_lp_formatted: '',
          },
        },
        selectedAllWarehouses: false,
        newIncludeQuoteTable: {},
        originType: {
          UNIQUE_WAREHOUSE: 'Centro de Distribuição Único',
          WAREHOUSE_STORE: 'Centro de Distribuição / Loja',
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'lpRequestData',
        'logisticProviderList',
        'warehouses',
        'modal',
        'clientInfo',
      ]),
      clientModulesList() {
        return {
          AUDIT: {
            label: 'Auditoria',
            value: 'Auditoria',
          },
          PLP: {
            label: 'Despacho',
            value: 'Despacho',
          },
          TRACKING: {
            label: 'Rastreamento',
            value: 'Rastreamento',
          },
          REVERSE: {
            label: 'Reversa',
            value: 'Reversa',
          },
          TRACKING_REVERSE: {
            label: 'Auditoria e Rastreamento',
            value: 'Auditoria e Rastreamento',
          },
          PLP_TRACKING: {
            label: 'Despacho e Rastreamento',
            value: 'Despacho e Rastreamento',
          },
          PLP_TRACKING_AUDIT: {
            label: 'Despacho, Rastreamento e Auditoria',
            value: 'Despacho, Rastreamento e Auditoria',
          },
          PLP_TRACKING_REVERSE: {
            label: 'Despacho, Rastreamento e Reversa',
            value: 'Despacho, Rastreamento e Reversa',
          },
        };
      },
      dynamicRules() {
        const baseRules = {
          client_name: [
            {
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
          ],
          client_email: [
            {
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
            {
              type: 'email',
              message: 'Email inválido',
              trigger: 'input',
            },
          ],
          client_phone_number: [
            {
              type: 'string',
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
          ],
          lp_contact_email: [
            {
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
            {
              type: 'email',
              message: 'Email inválido',
              trigger: 'input',
            },
          ],
          lp_contact_name: [
            {
              type: 'string',
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
          ],
          lp_contact_phone_number: [
            {
              type: 'string',
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
          ],
          contract_number: [
            {
              type: 'string',
              required: true,
              message: 'Esse campo é obrigatório',
              trigger: 'input',
            },
          ],
          logistic_provider: [
            {
              required: true,
              message: 'Preencha o nome da transportadora',
              trigger: 'input',
            },
          ],
          warehouses: [
            {
              validator: (rule, value, callback) => {
                if (!value || value.length === 0) {
                  callback(new Error('Informe os CNPJs dos centros de distribuição.'));
                } else {
                  callback();
                }
              },
              trigger: 'input',
            },
          ],
          has_contract: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('Confirme se essa integração está acordada.'));
                } else {
                  callback();
                }
              },
            },
          ],
          client_consent: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error('Confirme os termos e condições.'));
                } else {
                  callback();
                }
              },
            },
          ],
        };
        if (this.newIncludeQuoteTable.include_quote_table) {
          if (this.newIncludeQuoteTable.quote_table.origin_type === this.originType.WAREHOUSE_STORE) {
            baseRules.warehouse_initial_zip_code = [
              {
                type: 'string',
                required: true,
                message: 'Preencha o CEP Inicial ',
                trigger: 'input',
              },
              {
                message: 'Preencha o CEP no formato correto',
                validator: (rule, value, callback) => {
                  if (value && value.length < 9) {
                    callback(new Error(rule.message));
                  }
                  callback();
                },
              },
            ];
            baseRules.warehouse_final_zip_code = [
              {
                type: 'string',
                required: true,
                message: 'Preencha o CEP Final ',
                trigger: 'input',
              },
              {
                message: 'Preencha o CEP no formato correto',
                validator: (rule, value, callback) => {
                  if (value && value.length < 9) {
                    callback(new Error(rule.message));
                  }
                  callback();
                },
              },
            ];
          }
          if (this.newIncludeQuoteTable.quote_table.quote_table_type === 'INTELIENVIOS') {
            baseRules.inteli_envios_lp = [
              {
                type: ['array'],
                required: true,
                message: 'Selecione a transportadora desejada',
                validator: (rule, value, callback, fields) => {
                  const errors = [];
                  if (fields.quote_table.inteli_envios_lp.length < 1) {
                    if (fields && !fields.quote_table.inteli_envios_lp.length > 0) {
                      errors.push(new Error(rule.message, rule.field));
                      callback(errors);
                    }
                  }
                  callback(errors);
                },
              },
            ];
          }
          if (this.newIncludeQuoteTable.quote_table.additional_table_type === 'VTEX') {
            baseRules.vtex_origin_zip_code = [
              {
                type: 'string',
                required: true,
                message: 'Por favor, preencha o CEP Origem (VTEX)',
                trigger: 'input',
              },
              {
                message: 'Preencha o CEP no formato correto',
                validator: (rule, value, callback, fields) => {
                  if (fields.quote_table.vtex_origin_zip_code && value && value.length < 9) {
                    callback(new Error(rule.message));
                  }
                  callback();
                },
              },
            ];
          }
          if (this.newIncludeQuoteTable.quote_table.additional_table_type === 'LINX') {
            baseRules.linx_type = [
              {
                required: true,
                message: 'Preencha o tipo (LINX)',
                trigger: 'input',
              },
            ];
          }
          if (this.newIncludeQuoteTable.quote_table.quote_table_files.length === 0) {
            baseRules.file = [
              {
                required: true,
                validator: (rule, value, callback) => {
                  if (!value) {
                    callback(new Error('É necessário ter um arquivo anexado'));
                  } else {
                    callback();
                  }
                },
              },
            ];
          }
        }
        return baseRules;
      },
    },
    methods: {
      ...mapActions([
        'createNewLpRequestTickets',
        'getLogisticProviderList',
        'getWarehouses',
        'getClientInfo',
      ]),
      ...mapMutations(['setLoading', 'setModal']),
  
      updateQuoteTable(event) {
        this.newIncludeQuoteTable = event;
      },
      async createTickets(form) {
        const formattedInteliEnviosLp = form.quote_table.inteli_envios_lp.toString();
        const updatedForm = { ...form };

        updatedForm.quote_table.inteli_envios_lp_formatted = formattedInteliEnviosLp;
  
        updatedForm.should_integrate_lp = this.shouldIntegrationLp === false ? 'Não' : 'Sim';
  

        if (updatedForm.client_consent === 'Sim') {
          updatedForm.client_consent_sentence = '-Confirmo que essa integração está acordada e com contrato finalizado com o transportador escolhido.';
        }

        updatedForm.warehouses = this.selectedAllWarehouses ? 'Todos' : updatedForm.warehouses.join(',');
  
        let quoteTable;
        let attachments;
        if (updatedForm.include_quote_table) {
          quoteTable = { ...form.quote_table };
          attachments = quoteTable.quote_table_files;
          delete quoteTable.quote_table_files;
        }
        this.setLoading(true);

        const args = {
          lp_data: updatedForm,
          quote_table: quoteTable,
          attachments,
        };
  
        args.lp_data.company_name = this.clientInfo.common_name;
        args.lp_data.client_id = this.clientInfo.id.toString();

        await this.createNewLpRequestTickets(args);

        this.clearForm();
        this.clearSelectedWarehouses = true;
        this.selectedAllWarehouses = false;

        this.setLoading(false);
      },
      clearForm() {
        this.lpData.client_name = '';
        this.lpData.client_phone_number = '';
        this.lpData.client_email = '';
        this.lpData.lp_contact_name = '';
        this.lpData.lp_contact_phone_number = '';
        this.lpData.lp_contact_email = '';
        this.lpData.additional_information = '';
        this.lpData.contract_number = '';
  
        this.lpData.has_contract = false;
        this.lpData.client_consent = false;
        this.lpData.include_quote_table = false;

        this.lpData.logistic_provider = [];
        this.lpData.warehouses = [];
        this.lpData.client_modules = [];

        this.lpData.quote_table.vtex_origin_zip_code = '';
        this.lpData.quote_table.linx_type = '';
        this.lpData.quote_table.warehouse_initial_zip_code = '';
        this.lpData.quote_table.warehouse_final_zip_code = '';
        this.lpData.quote_table.client_ids_to_replicate = '';
        this.lpData.quote_table.quote_table_files = [];
        this.lpData.quote_table.inteli_envios_lp_formatted = '';

        this.lpData.quote_table.inteli_envios_lp = [];
      },
      handleSelectAll(fields, values) {
        this.selectedAllWarehouses = true;

        const varFields = fields;
        varFields.warehouses = values;
      },
      handleClearFilter(fields) {
        this.selectedAllWarehouses = false;

        const varFields = fields;
        varFields.warehouses.length = 0;
      },
      handleWarehouseSelection(fields) {
        const federalTaxPayerIds = this.warehouses.map(warehouse => warehouse.federal_tax_payer_id);
        this.selectedAllWarehouses = federalTaxPayerIds.every(id => fields.warehouses.includes(id));
      },
      openModal() {
        this.setModal(true);
      },
      closeModal() {
        this.setModal(false);
      },
    },
    mounted() {
      this.getLogisticProviderList();
      this.getWarehouses();
      this.getClientInfo();
    },
    components: {
      ScInput,
      ScField,
      ScForm,
      ScPageBase,
      ScButton,
      ScSelect,
      ScRadio,
      ScSwitch,
      ScCheckbox,
      NewQuoteTableForm,
      ScTermModal,
      ScMultipleSelection,
      ScMultipleWarehouseSearch,
      ScToast,
      ScAutocomplete,
      ScTaginput,
    },
  };
</script>

<style lang="scss">
  @import "~@intelipost-js/secure-ui/src/scss/variables";

  $error: #e84c3d;
  $primary-form: #3670d6;

  input[name="lp_contact_email"].is-danger, input[name="client_email"].is-danger {
   text-transform: lowercase;
  }
  input[name="lp_contact_email"].is-success, input[name="client_email"].is-danger {
   text-transform: lowercase;
  }
  .detail-logistic-provider {
    color: gray;
    font-size: 0.9rem;
  }
  .error {
    color: $error;
    font-size: .80rem;
    margin-left: 5px;
    margin-top: 5px;
  }
  .required {
    color: $error;
  }
  .title-company {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.16px;
    color: #010906;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .field-company label{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;
    color: #39554A;
  }
  .term {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.16px; 
    color: $primary;
  }
  .term-align {
    margin-top: 10px;
    text-align: right;
  }
  .term-text {
    color: $primary-form;
  }
  .multiple-select {
    margin-top: 5px;
  }
  .b-checkbox.checkbox.term-check
    input[type=checkbox]:checked+.check {
      background-color: $link;
      border-color: $link;
  }
  .switch.switch-add
    input[type=checkbox]:checked+.check {
    background: $link;
  }
  .lp-select select {
    width: 400px;
  }
  
</style>
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/logistic-provider-form/NewLogisticProviderForm.vue